import React, { useState } from 'react';
import './Login.css';
import { API_BASE } from '../config';

function Login({ onClose, onNavigate }) {
  const [loginType, setLoginType] = useState('');
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleLoginTypeSelect = (type) => {
    setLoginType(type);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const loginId = formData.email.trim();
    const password = formData.password;

    try {
      const response = await fetch(`${API_BASE}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ loginId, password, loginType }),
      });
  
      const data = await response.json();
  
      if (data.success) {
        // Store token in localStorage
        localStorage.setItem('authToken', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.setItem('loginType', loginType); // remember Partner vs Client
  
        alert(`${loginType} login successful!`);
        console.log('Login successful:', data.user);
        onClose();
  
        if (loginType === 'Partner') {
          onNavigate && onNavigate('client-details');
        } else {
          onNavigate && onNavigate('client-dashboard');
        }
      } else {
        alert(data.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      alert('Login failed. Please try again.');
    }
  };

  const handleBackToSelection = () => {
    setLoginType('');
    setFormData({ email: '', password: '' });
  };

  return (
    <div className="login-overlay">
      <div className="login-modal">
        <button className="close-btn" onClick={onClose}>&times;</button>
        
        {!loginType ? (
          // Login type selection screen
          <div className="login-selection">
            <h2>Choose Login Type</h2>
            <p>Please select your login type to continue</p>
            
            <div className="login-options">
              <div className="login-option" onClick={() => handleLoginTypeSelect('Client')}>
                <div className="option-icon">👤</div>
                <h3>Client Login</h3>
                <p>Access your investment portfolio and risk profile</p>
              </div>
              
              <div className="login-option" onClick={() => handleLoginTypeSelect('Partner')}>
                <div className="option-icon">🏢</div>
                <h3>Partner Login</h3>
                <p>Access partner dashboard and client management</p>
              </div>
            </div>
          </div>
        ) : (
          // Login form screen
          <div className="login-form-container">
            <button className="back-btn" onClick={handleBackToSelection}>← Back</button>
            <h2>{loginType} Login</h2>
            
            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="email">
                  {loginType === 'Partner' ? 'Login ID' : 'Email Address'}
                </label>
                <input
                  type={loginType === 'Partner' ? 'text' : 'email'}
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  placeholder={loginType === 'Partner' ? 'Enter your login ID' : 'Enter your email'}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter your password"
                />
              </div>
              
              <button type="submit" className="login-submit-btn">
                Login as {loginType}
              </button>
              
              <div className="login-footer">
                <a href="#forgot">Forgot Password?</a>
                {loginType === 'Client' && (
                  <p>Don't have an account? <a href="#signup">Sign up here</a></p>
                )}
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;